export const saveIsShow = ({ commit }, payload) => {
  commit('saveIsShow', payload);
}
// 设置shopify 的APP对象
export const setShopifyAppObj = ({ commit }, val) => {
  commit('setShopifyAppObj', val);
}
// 套餐类型
export const setPackagType = ({ commit }, val) => {
  commit('setPackagType', val);
}
//设置店铺货币符号
export const setCurrencySymbol = ({ commit }, val) => {
  commit('setCurrencySymbol', val);
}
//设置付费套餐类型
export const setPricingPlanId = ({ commit }, val) => {
  commit('setPricingPlanId', val);
}
//是否开启我们app为默认拓展
export const setPostPurchaseActive = ({ commit }, val) => {
  commit('setPostPurchaseActive', val);
}
export const setPostShow = ({ commit }, val) => {
  commit('setPostShow', val);
}
export const serUserName = ({ commit }, val) => {
  commit('serUserName', val);
}